import { render, staticRenderFns } from "./Uploading.vue?vue&type=template&id=3e8c60c3&scoped=true"
var script = {}
import style0 from "./Uploading.vue?vue&type=style&index=0&id=3e8c60c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8c60c3",
  null
  
)

export default component.exports